import { background } from './classics4.mjs'
import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/250429/classics4-le_newera-{nnn}.png',
}

export default {
  supports360: false,
  layers: [body, background],
  resolveOptions: () => ({}),
}
